<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :dark="barColor !== 'rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.7)'"
    :right="$vuetify.rtl"
    :src="barImage"
    app
    width="300"
    v-bind="$attrs"
    clipped
  >
    <template v-slot:img="props">
      <v-img
        :gradient="`to bottom, ${barColor}`"
        v-bind="props"
      />
    </template>

    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title class="text-uppercase font-weight-regular text-h3">
          <span class="ml-2 mr-6" />
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list
      expand
      nav
    >
      <div />

      <template v-for="(item, i) in items">
        <base-item-group
          v-if="item.children && item.if($store)"
          :key="`group-${i}`"
          :item="item"
        />

        <base-item
          v-if="!item.children && item.if($store)"
          :key="`item-${i}`"
          :item="item"
        />
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  // Utilities
  import {
    mapState,
  } from 'vuex'

  export default {
    name: 'DashboardCoreDrawer',

    props: {
      expandOnHover: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      items: [
        {
          icon: 'mdi-view-dashboard',
          title: 'СВОДКА',
          if: (store) => !store.state.roles[4],
          to: '/client/dashboard',
        },
        //  {
        //   icon: 'mdi-desktop-mac',
        //   title: 'МОНИТОРИНГ',
        //   if: (store) => true,
        // },
        {
          icon: 'mdi-point-of-sale',
          title: 'ТОЧКИ ОБСЛУЖИВАНИЯ',
          group: '/client',
          if: (store) => store.state.access[15][0] || store.state.access[12][0],
          children: [
            {
              title: 'ТОЧКИ ОБСЛУЖИВАНИЯ',
              to: 'point/list',
              if: (store) => store.state.access[15][0],
            },
            {
              title: 'МЕСТА ОБСЛУЖИВАНИЯ ',
              to: 'place/list',
              if: (store) => store.state.access[12][0],
            },
            {
              title: 'Конфигурации',
              to: 'configuration/list',
              if: (store) => store.state.access[28][0],
            },
            {
              title: 'Задания',
              to: 'task/list',
              if: (store) => true,
            },
            {
                title: 'Шаблоны задач',
                to: 'task_template/list',
                if: (store) => true,
            },
            {
              title: 'Сверки итогов',
              to: 'finalrecon/list',
              if: (store) => true,
            },
          ],
        },
        {
        icon: 'mdi-qrcode-scan',
        title: 'QR-платежи',
        group: '/client',
        if: (store) => store.state.access[31][0],
        children: [
          {
            title: 'ПРОФИЛИ',
            to: 'sbpprofile/list',
            if: (store) => store.state.access[31][0],
          },
          {
            title: 'Операции',
            to: 'sbp/list',
            if: (store) => true,
          },
        ]
      },
        {
          icon: 'mdi-credit-card-outline',
          title: 'ПЛАТЕЖНЫЕ ОПЕРАЦИИ',
          group: '/client',
          if: (store) => store.state.access[19][0] || store.state.access[20][0],
          children: [
            {
              title: 'НАЧИСЛЕНИЯ',
              to: 'order/list',
              if: (store) => store.state.access[19][0],
            },
            {
              title: 'ПЛАТЕЖИ',
              to: 'payment/list',
              if: (store) => store.state.access[20][0],
            },
          ],
        },
        {
          icon: 'mdi-cash-register',
          title: 'ФИСКАЛИЗАЦИЯ',
          group: '/client',
          if: (store) => store.state.access[21][0],
          children: [
            {
              title: 'ФИСКАЛЬНЫЕ ОПЕРАЦИИ',
              to: 'fiscal/list',
              if: (store) => store.state.access[21][0],
            },
            {
              title: 'СПИСОК ККТ',
              to: 'kkt/list',
              if: (store) => store.state.access[14][0],
            },
          ],
        },
        {
          icon: 'mdi-bank-transfer',
          title: 'ПЛАТЕЖНАЯ СИСТЕМА',
          group: '/client',
          if: (store) => store.state.access[18][0] || store.state.access[17][0] || store.state.access[16][0] || store.state.access[22][0],
          children: [
            {
              title: 'ТОВАРЫ И УСЛУГИ',
              to: 'item/list',
              if: (store) => store.state.access[18][0],
            },
            {
              title: 'ПОЛУЧАТЕЛИ',
              to: 'recipient/list',
              if: (store) => store.state.access[17][0],
            },
            {
              title: 'ПЛАТЕЛЬЩИКИ',
              to: 'member/list',
              if: (store) => store.state.access[22][0],
            },
            {
              title: 'Операторы',
              to: 'operator/list',
              if: (store) => store.state.access[16][0],
            },
            {
              title: 'Заведение получателей и услуг',
              to: 'service/create',
              if: (store) => store.state.access[17][0] && store.state.access[18][0],
            },
            {
              title: 'СОЗДАТЬ НАЧИСЛЕНИЕ',
              if: (store) => store.state.access[19][0],
              to: 'order/create',
            },
          ],
        },
        {
          icon: 'mdi-devices',
          title: 'ОБОРУДОВАНИЕ',
          group: '/client',
          if: (store) => store.state.access[13][0] || store.state.access[14][0],
          children: [
            {
              title: 'СПИСОК ОБОРУДОВАНИЯ',
              to: 'equipment/list',
              if: (store) => store.state.access[14][0],
            },
            {
              title: 'КАТАЛОГ УСТРОЙСТВ',
              to: 'device/list',
              if: (store) => store.state.access[13][0],
            },
          ],
        },
        {
          icon: 'mdi-barcode-scan',
          title: 'ТОВАРОУЧЕТ',
          group: '/client',
          if: (store) => !store.state.roles[4],
          children: [
            {
              title: 'КАТЕГОРИИ',
              to: 'category/list',
              if: (store) => store.state.access[25][0],
            },
            {
              title: 'номенклатура',
              to: 'nomenclature/list',
              if: (store) => store.state.access[27][0],
            },
            {
              title: 'Поставщики',
              to: 'recipient/list',
              if: (store) => store.state.access[17][0],
            },
            {
              title: 'Приходы',
              to: 'revenue/list',
              if: (store) => true,
            },
            {
              title: 'Перемещения',
              to: 'productMovement/list',
              if: (store) => true,
            },
            {
              title: 'Остатки',
              to: 'remainder/view',
              if: (store) => true,
            },
            {
              title: 'Инвентаризация',
              to: 'inventory/list',
              if: (store) => true,
            },
          ]
        },
        {
          icon: 'mdi-sale',
          title: 'Лояльность',
          group: '/client',
          if: (store) => !store.state.roles[4],
          children: [
            {
              title: 'Атрибуты',
              to: 'cvariable/list/2',
              if: (store) => true,
            },
            {
              title: 'Счета',
              to: 'accountcustomer/list/2',
              if: (store) => true,
            },
            {
              title: 'Программы',
              to: 'campaign/list/2',
              if: (store) => true,
            },
            {
              title: 'Транзакции',
              to: 'transaction/customer/list/2',
              if: (store) => true,
            },
            {
                title: 'Участники',
                to: 'userprofile/list/2',
                if: (store) => true,
            },
          ]
        },
        {
          icon: 'mdi-credit-card-marker',
          title: 'КОМПАНИЯ',
          group: '/client',
          if: (store) => store.state.access[0][0] || store.state.access[23][0],
          children: [
            {
              title: 'СОТРУДНИКИ',
              to: 'user/list',
              if: (store) => store.state.access[0][0],
            },
            {
              title: 'РОЛИ',
              to: 'role/list',
              if: (store) => store.state.access[23][0],
            },
          ],
        },
        {
        icon: 'mdi-account',
        title: 'Профиль',
        group: '/client',
        if: (store) => true,
        children: [
          {
            title: 'Учетная запись',
            to: 'profile/main',
            if: (store) => true,
          },
          {
            title: 'Смена пароля',
            to: 'profile/password',
            if: (store) => true,
          },
        ]
      },
          {
              icon: 'mdi-calendar-clock-outline',
              title: 'Уведомления',
              group: "/client",
              if: (store) => store.state.access[36][0],
              children: [
                  {
                      title: "Календарь уведомлений",
                      to: "Reminder",
                      if: (store) => store.state.access[36][0],
                  },
                  {
                      title: "Настройка уведомлений",
                      to: "SettingsReminder",
                      if: (store) => store.state.access[36][0],
                  }
              ]
          },
        {
          icon: 'mdi-face-man-profile',
          title: 'Идентификация',
          group: '/client',
          if: (store) => !store.state.roles[4],
          children: [
            {
              title: 'Профили MAX',
              to: "profile/list",
              if: (store) => true,
            },
          ]
        },
        {
          icon: 'mdi-connection',
          title: 'Интеграции',
          to: '/client/integration/list',
          if: (store) => store.state.access[33][0],
        },
        {
          icon: 'mdi-badge-account-horizontal-outline',
          title: 'СКУД',
          group: '/client',
          // if: (store) => !!store.state.roles[2] || !!store.state.roles[4],
          if: (store) => store.state.access[44][0],
          children: [
            {
              title: 'Карты доступа',
              to: 'skud/card/list',
              if: (store) => store.state.access[44][0],
            },
            {
              title: 'Дашборд',
              to: 'skud/dashboard',
              if: (store) => store.state.access[44][10],
            },
            {
              title: 'Проходы',
              to: 'skud/passage/list',
              if: (store) => store.state.access[44][1],
            },
            {
              title: 'Отчёты о проходах',
              to: 'skud/report',
              if: (store) => store.state.access[44][2],
            },
            {
              title: 'Визиты',
              to: 'skud/visit/list',
              if: (store) => store.state.access[44][3],
            },
            {
              title: 'Гостевые пропуска',
              to: 'skud/guest/list',
              if: (store) => store.state.access[44][4],
            },
            {
              title: 'Команды точкам',
              to: 'skud/command',
              if: (store) => store.state.access[44][8],
            },
          ]
        },
        {
          icon: 'mdi-exit-to-app',
          title: 'Выход',
          to: '/logout',
          if: (store) => true,
        },
      ],
    }),

    computed: {
      ...mapState(['barColor', 'barImage']),
      drawer: {
        get () {
          return this.$store.state.drawer
        },
        set (val) {
          this.$store.commit('SET_DRAWER', val)
        },
      },
      profile () {
        return {
          avatar: true,
          group: '',
          title: this.$store.state.user.name,
          children: [
            {
              to: 'profile',
              title: 'Профиль',
            },
          ],
        }
      },
    },

    watch: {
      '$vuetify.breakpoint.smAndDown' (val) {
        this.$emit('update:expandOnHover', !val)
      },
    },
  }
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'

  #core-navigation-drawer
    &.v-navigation-drawer--mini-variant
      .v-list-item
        justify-content: flex-start !important

      .v-list-group--sub-group
        display: block !important

    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 0px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>
